module.exports = "/_next/static/images/sd-8f0ac64a4c068be71e6a7565738ab5a5.svg";